import React, { useState, useEffect } from 'react';
import '../styles/Scheduler.css';
import { getAllEvents, addEvent, updateEvent, deleteEvent, bulkDeleteEvents } from '../services/api';

function Scheduler() {
  const [events, setEvents] = useState([]);
  const [newEvent, setNewEvent] = useState({ clientId: '', title: '', date: '' });
  const [editEvent, setEditEvent] = useState(null);
  const [selectedEvents, setSelectedEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const data = await getAllEvents();
        setEvents(data);
      } catch (err) {
        console.error('Failed to fetch events:', err);
      }
    };
    fetchEvents();
  }, []);

  const handleAddEvent = async (e) => {
    e.preventDefault();
    try {
      const response = await addEvent(newEvent);
      setEvents([...events, response]);
      setNewEvent({ clientId: '', title: '', date: '' });
    } catch (err) {
      alert('Failed to add event.');
    }
  };

  const handleUpdateEvent = async (e) => {
    e.preventDefault();
    try {
      await updateEvent(editEvent.id, editEvent);
      setEvents(events.map(e => e.id === editEvent.id ? editEvent : e));
      setEditEvent(null);
    } catch (err) {
      alert('Failed to update event.');
    }
  };

  const handleDeleteEvent = async (eventId) => {
    if (window.confirm('Are you sure you want to delete this event?')) {
      try {
        await deleteEvent(eventId);
        setEvents(events.filter(e => e.id !== eventId));
      } catch (err) {
        alert('Failed to delete event.');
      }
    }
  };

  const handleBulkDelete = async () => {
    if (window.confirm('Are you sure you want to delete selected events?')) {
      try {
        await bulkDeleteEvents(selectedEvents);
        setEvents(events.filter(e => !selectedEvents.includes(e.id)));
        setSelectedEvents([]);
      } catch (err) {
        alert('Failed to delete events.');
      }
    }
  };

  const toggleSelectEvent = (eventId) => {
    setSelectedEvents(prev => 
      prev.includes(eventId) ? prev.filter(id => id !== eventId) : [...prev, eventId]
    );
  };

  return (
    <div className="ap-scheduler">
      <h2 className="ap-scheduler-title">Scheduler</h2>
      <form className="ap-event-form" onSubmit={handleAddEvent}>
        <input className="ap-event-input" name="clientId" placeholder="Client ID" value={newEvent.clientId} onChange={(e) => setNewEvent({ ...newEvent, clientId: e.target.value })} required />
        <input className="ap-event-input" name="title" placeholder="Event Title" value={newEvent.title} onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })} required />
        <input className="ap-event-input" name="date" type="date" value={newEvent.date} onChange={(e) => setNewEvent({ ...newEvent, date: e.target.value })} required />
        <button className="ap-event-btn" type="submit">Add Event</button>
      </form>
      {selectedEvents.length > 0 && (
        <button className="ap-bulk-delete-btn" onClick={handleBulkDelete}>Delete Selected ({selectedEvents.length})</button>
      )}
      <ul className="ap-event-list">
        {events.map((event) => (
          <li key={event.id} className="ap-event-item">
            <input
              type="checkbox"
              checked={selectedEvents.includes(event.id)}
              onChange={() => toggleSelectEvent(event.id)}
            />
            <span>{event.clientName} - {event.title} - {event.date}</span>
            <button className="ap-edit-btn" onClick={() => setEditEvent(event)}>Edit</button>
            <button className="ap-delete-btn" onClick={() => handleDeleteEvent(event.id)}>Delete</button>
          </li>
        ))}
      </ul>
      {editEvent && (
        <form className="ap-edit-event-form" onSubmit={handleUpdateEvent}>
          <h3 className="ap-edit-title">Edit Event</h3>
          <input className="ap-event-input" name="clientId" value={editEvent.clientId} onChange={(e) => setEditEvent({ ...editEvent, clientId: e.target.value })} required />
          <input className="ap-event-input" name="title" value={editEvent.title} onChange={(e) => setEditEvent({ ...editEvent, title: e.target.value })} required />
          <input className="ap-event-input" name="date" type="date" value={editEvent.date} onChange={(e) => setEditEvent({ ...editEvent, date: e.target.value })} required />
          <button className="ap-event-btn" type="submit">Save</button>
          <button className="ap-cancel-btn" type="button" onClick={() => setEditEvent(null)}>Cancel</button>
        </form>
      )}
    </div>
  );
}

export default Scheduler;